import { Component, OnDestroy, OnInit } from '@angular/core';
import { ViewColumnComponent } from '../../view-column.component';
import { AppStates } from '../../application-controller/store/states';
import { Store } from '@ngrx/store';
import { ViewColActions } from '../../application-controller/store/actions';
import { SessionStates } from '../../modules/session/session-controller/states';
import { SessionSelectors } from '../../modules/session/session-controller/selectors';
import { DocumentShortCodesClass } from 'blg-akaun-ts-lib';
import { SubSink } from 'subsink2';

@Component({
  selector: 'app-util-generic-document-view',
  templateUrl: './generic-document-view.component.html',
  styleUrls: ['./generic-document-view.component.css']
})


export class GenericDocumentViewComponent  extends ViewColumnComponent implements OnInit, OnDestroy {
  protected subs = new SubSink();
  genericDoc$ = this.sessionStore.select(SessionSelectors.selectGenericDocumentPopup);
  docNo;
  constructor(
    private readonly sessionStore: Store<SessionStates>,
    private readonly appStore: Store<AppStates>) {
    super();
  }

  ngOnInit() {
    this.subs.sink = this.genericDoc$.subscribe(resolve => {
      const docShortCode = DocumentShortCodesClass.serverDocTypeToShortCodeMapper(resolve.bl_fi_generic_doc_hdr.server_doc_type?.toString());
      const docNo = resolve.bl_fi_generic_doc_hdr.server_doc_1?.toString();
      this.docNo = `${docShortCode} [${docNo}]`;
    });
  }

  onReturn() {
    this.appStore.dispatch(ViewColActions.resetIndex({index: 0}));
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
